import React, { Component } from "react";
import Pricing from "./components/Price/index";
import ServicesHome from "./components/SerrvicesHome/index";
import Review from "./components/Review/index";
// import GalleryHome from "./components/GalleryHome/index";
import AppointmentHome from "./components/AppointmentHome/index";
import { URL_KKN_JOENSUU } from "../url/index";
import { withTranslation } from "react-i18next";
import First from "./components/Splash/First";
import Second from "./components/Splash/Second";
import Third from "./components/Splash/Third";
import Fourth from "./components/Splash/Fourth";
import Contact from "../../components/Contact/index";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenWeekTime: false,
      isOpenWeekendTime: false,
      isShopDay: false,
      currentSlide: 0
    };
  }

  componentDidMount() {
    this.setShopStatus();
    this.interval = setInterval(this.nextSlide, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  setShopStatus = () => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const today = new Date();
    const dayOfWeek = today.getDay(); // 0=Sunday, 1=Monday, ..., 6=Saturday

    let isOpenWeekTime = false;
    let isOpenWeekendTime = false;
    let isShopDay = false;

    // Monday-Friday: 09:00-18:00
    if (dayOfWeek >= 1 && dayOfWeek <= 5) {
      isShopDay = true;
      isOpenWeekTime = hours >= 9 && (hours < 18 || (hours === 18 && minutes === 0));
    }
    // Saturday: 09:00-17:00
    else if (dayOfWeek === 6) {
      isShopDay = true;
      isOpenWeekTime = hours >= 9 && (hours < 17 || (hours === 17 && minutes === 0));
    }
    // Sunday: 10:00-16:00
    else if (dayOfWeek === 0) {
      isShopDay = true;
      isOpenWeekendTime = hours >= 10 && (hours < 16 || (hours === 16 && minutes === 0));
    }

    this.setState({
      isOpenWeekTime,
      isOpenWeekendTime,
      isShopDay,
    });
  };

  nextSlide = () => {
    const { currentSlide } = this.state;
    const totalSlides = 4; 
    this.setState({
      currentSlide: (currentSlide + 1) % totalSlides
    });
  }

  render() {
    const { isOpenWeekTime, isOpenWeekendTime, isShopDay, currentSlide } = this.state;
    return (
      <div>
        <div className="banner_w3lspvt" id="home">
          <div className="csslider infinity" id="slider1">
            <input type="radio" name="slides" checked={currentSlide === 0} id="slides_1" />
            <input type="radio" name="slides" checked={currentSlide === 1} id="slides_2" />
            <input type="radio" name="slides" checked={currentSlide === 2} id="slides_3" />
            <input type="radio" name="slides" checked={currentSlide === 3} id="slides_4" />
            <ul className="banner_slide_bg">
              <li>
                <First
                  isShopDay={isShopDay}
                  isOpenWeekTime={isOpenWeekTime}
                  isOpenWeekendTime={isOpenWeekendTime}
                  URL_KKN_JOENSUU={URL_KKN_JOENSUU}
                />
              </li>
              <li>
                <Second
                  isShopDay={isShopDay}
                  isOpenWeekTime={isOpenWeekTime}
                  isOpenWeekendTime={isOpenWeekendTime}
                  URL_KKN_JOENSUU={URL_KKN_JOENSUU}
                />
              </li>
              <li>
                <Third
                  isShopDay={isShopDay}
                  isOpenWeekTime={isOpenWeekTime}
                  isOpenWeekendTime={isOpenWeekendTime}
                  URL_KKN_JOENSUU={URL_KKN_JOENSUU}
                />
              </li>
              <li>
                <Fourth
                  isShopDay={isShopDay}
                  isOpenWeekTime={isOpenWeekTime}
                  isOpenWeekendTime={isOpenWeekendTime}
                  URL_KKN_JOENSUU={URL_KKN_JOENSUU}
                />
              </li>
            </ul>
            <div className="navigation">
              <div>
                <label htmlFor="slides_1"></label>
                <label htmlFor="slides_2"></label>
                <label htmlFor="slides_3"></label>
                <label htmlFor="slides_4"></label>
              </div>
            </div>
          </div>
        </div>
        <Pricing />
        <ServicesHome />
        <AppointmentHome />
        <Review />
        <Contact/>
      </div>
    );
  }
}
export default withTranslation("global")(Home);
